module.exports = __webpack_public_path__ + "apple-icon-60x60.png?3154d3fd3561d9cc20322cdffc203077";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-60x60.png
// module id = 133
// module chunks = 0